import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private isDesktop: boolean = true;

  constructor() {
    this.checkDeviceType();
    window.addEventListener('resize', this.checkDeviceType.bind(this));
  }

  private checkDeviceType() {
    // Adjust this threshold as needed. Here, 768px is a common breakpoint for tablets.
    this.isDesktop = window.innerWidth > 768;
  }

  getIsDesktop(): boolean {
    return this.isDesktop;
  }
}
